import { render, staticRenderFns } from "./UnpostedBillDetails.vue?vue&type=template&id=af70c15a&"
import script from "./UnpostedBillDetails.vue?vue&type=script&lang=js&"
export * from "./UnpostedBillDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports